import specializationMembershipFields from 'bundles/accomplishments/promises/specializationMembershipFields';
import specializationMembershipsPromise from 'bundles/catalogP/promises/specializationMemberships';

export default function (code: $TSFixMe) {
  const query = Object.assign({}, specializationMembershipFields, {
    q: 'byCode',
    certificateCode: code,
  });

  query.includes.signatureTrackProfile = {
    fields: ['firstName', 'middleName', 'lastName'],
  };

  return specializationMembershipsPromise(query).then(function (specializationMemberships: $TSFixMe) {
    return specializationMemberships.first();
  });
}
